export default {
    WARNING_DUPLICATE: 'Llave de artículo duplicada encontrada en la tienda: ',
    INVALID_STORE: 'Intentaste analizar una tienda inexistente.',
    INVALID_STORE_REFRESH: 'Intentaste actualizar una tienda no válida:',
    INVALID_ITEM_SELECTION: 'Seleccionaste un artículo no válido.',
    PURCHASE_INVALID_STORE: 'Intentaste comprar un artículo que no existe en la tienda: ',
    SELL_INVALID_ITEM: 'Intentaste vender un artículo no válido.',
    ITEM_OUT_OF_STOCK: 'Este artículo está actualmente agotado.',
    NOT_ENOUGH_CURRENCY: 'No tienes suficiente oro para comprar este artículo.',
    NOT_ENOUGH_SPACE: 'No tienes suficiente espacio en tu inventario.',
    CANNOT_SELL_ITEM: 'No puedes vender este artículo.',
    ACTION_STORE_NOT_OPEN: 'Intentaste realizar una acción en una tienda que no está abierta.',
    CHEATER: 'Te han marcado por hacer trampa. No puedes comprar nada.',
    RESTRICTED_STORE: 'Esta tienda no acepta ningún artículo.',
    RESTRICTED_ITEM: 'Este artículo no se puede vender aquí.',
    INVALID_ITEM_COUNT: 'Has introducido una cantidad no válida de artículos.',
    HOLLOW_ADMIN: 'Como administrador no puedes interactuar con la economía.'
} as const;
